export const PUT_QUOTATION = '/internal/settings/v1/settings/general/quotation'